// Reads Vite-style env vars without referencing `import.meta` directly.
//
// Why: `import.meta` is ESM-only syntax. If it appears literally in
// libs/core's CJS-compiled dist .js files, Node 22's auto-detect-module
// (enabled by default) treats those files as ESM and the CJS exports
// blow up with `ReferenceError: exports is not defined in ES module scope`.
//
// Solution: web-side bootstrap copies `import.meta.env` into
// `globalThis.__VITE_ENV__` (and `import.meta.hot` into `__VITE_HOT__`)
// at app startup. libs/core reads those globals — works in browser/Vite
// and is undefined-safe on the server.

declare global {
	// eslint-disable-next-line no-var
	var __VITE_ENV__: Record<string, string | undefined> | undefined;
	// eslint-disable-next-line no-var
	var __VITE_HOT__: unknown | undefined;
}

export function getViteEnv(key: string): string | undefined {
	return globalThis.__VITE_ENV__?.[key];
}

export function isViteHot(): boolean {
	return globalThis.__VITE_HOT__ != null;
}

/**
 * PD-16161 — whether this is the production build of the web app. The staging
 * and local builds run under Vite modes of their own (`--mode staging`, and
 * `development` for the dev server), so `production` is exactly the build
 * that reaches customers. Testing aids that must never be offered to a
 * customer key off this; on the server, where no Vite env exists, it answers
 * true so the safe side is the default.
 */
export function isProductionBuild(): boolean {
	const mode = getViteEnv('MODE');
	return mode == null || mode === 'production';
}
